"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _sharedIntlProviderHOC = _interopRequireDefault(require("../hocs/sharedIntlProviderHOC"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
/*
* flow:
* 1) fire ajax call to send
* 2) render page
* 3) submit info
* 4) move flow forward correctly (signup, transactable, profile)
*   - use this.props.onSuccessfulSubmit
*
* Dependent Props for display:
  - user
  - componentWillMountAction
  - updateAction

  Callback Props:
  - finalCallback
  - finalCBArg
 */
var VerifyEmail = /*#__PURE__*/function (_React$Component) {
  _inherits(VerifyEmail, _React$Component);
  function VerifyEmail(props) {
    var _this;
    _classCallCheck(this, VerifyEmail);
    _this = _callSuper(this, VerifyEmail, [props]);
    _this.state = {
      sentCodeToUser: false,
      errorMessage: ""
    };
    _this.prepData = _this.prepData.bind(_assertThisInitialized(_this));
    _this.sendVerification = _this.sendVerification.bind(_assertThisInitialized(_this));
    _this.onEmailCodeReturn = _this.onEmailCodeReturn.bind(_assertThisInitialized(_this));
    _this.prepData = _this.prepData.bind(_assertThisInitialized(_this));
    _this.onSubmitVerificationCode = _this.onSubmitVerificationCode.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(VerifyEmail, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      //add ajax call to start then render form
      var sendCodeToUserEmail = this.props.componentWillMountAction;
      sendCodeToUserEmail(this.onEmailCodeReturn);
    }
  }, {
    key: "prepData",
    value: function prepData(event) {
      event.preventDefault();
      var input = document.getElementById("email-verify");
      var inputValue = input.value;
      if (4 > inputValue.length) {
        var errorMsg = this.props.intl.formatMessage({
          id: 'shared_components.verify_email.add_valid_code',
          defaultMessage: 'Please add a valid code'
        });
        return this.setState({
          errorMessage: errorMsg
        });
      } else {
        var payload = {
          email_verification_code: inputValue
        };
        var updateAction = this.props.updateAction;
        var payloadStr = JSON.stringify(payload);
        return updateAction(payloadStr, this.onSubmitVerificationCode);
      }
    }
  }, {
    key: "onSubmitVerificationCode",
    value: function onSubmitVerificationCode(data, textStatus, jqHXR) {
      if ("success" === textStatus) {
        return this.props.callback(data, textStatus, true);
      } else {
        var errorMsg = data.responseJSON.error;
        this.setState({
          errorMessage: errorMsg
        });
      }
    }
  }, {
    key: "onEmailCodeReturn",
    value: function onEmailCodeReturn(response, textStatus, jqXHR) {
      // this.state.sentCodeToUser => true;
      var emailSent = "success" === textStatus;
      this.setState({
        sentCodeToUser: emailSent
      });
    }
  }, {
    key: "sendVerification",
    value: function sendVerification(event) {
      event.preventDefault();
      var sendCodeToUserEmail = this.props.componentWillMountAction;
      sendCodeToUserEmail(this.onEmailCodeReturn);
      analyticsIntegrations.resendVerification();
    }
  }, {
    key: "render",
    value: function render() {
      // data needs: user email, user ssoid, user first name
      var helperEmailText = this.props.intl.formatMessage({
        id: 'shared_components.verify_email.help_peerspace',
        defaultMessage: 'Hi Peerspace, can you help me verify my email address. My user ID is {ssoId}. Thanks! {firstName}'
      }, {
        ssoId: this.props.user.SSOid,
        firstName: this.props.user.first_name
      });
      var inputClass = "col-xs-8";
      if (this.state.errorMessage) {
        inputClass = "col-xs-8 input-error";
      }
      var zendeskLocale = _sharedIntlProviderHOC.default.getZendeskLocale();
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "verify-email",
        className: "col-xs-12"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "text-center"
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.verify_email.verify_email",
        defaultMessage: "Verify Your Email"
      })), /*#__PURE__*/_react.default.createElement("form", {
        id: "email-verify-form"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "text-center"
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.verify_email.check_email",
        defaultMessage: "Please check your email and enter the 4-digit code below to make sure your account is valid."
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-6 col-xs-offset-3 flex middle"
      }, /*#__PURE__*/_react.default.createElement("input", {
        id: "email-verify",
        className: inputClass,
        type: "text",
        maxLength: "4",
        placeholder: "XXXX"
      }), /*#__PURE__*/_react.default.createElement("button", {
        className: "col-xs-4 btn btn-primary classic margin-md-left",
        onClick: this.prepData
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.verify_email.check_email_button",
        defaultMessage: "Verify"
      }))), /*#__PURE__*/_react.default.createElement("p", {
        className: "text-danger col-xs-6 col-xs-offset-3"
      }, this.state.errorMessage)), /*#__PURE__*/_react.default.createElement("p", {
        className: "col-xs-12 text-center"
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.verify_email.didnt_get_email",
        defaultMessage: "Didn\u2019t get an email? It can take a few minutes, but also check your Spam and Promotions folder."
      })), /*#__PURE__*/_react.default.createElement("p", {
        className: "col-xs-12 text-center"
      }, /*#__PURE__*/_react.default.createElement("span", {
        id: "resend-email-code",
        onClick: this.sendVerification
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "underline"
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.verify_email.resend_code",
        defaultMessage: "Resend code"
      }))), /*#__PURE__*/_react.default.createElement("span", null, "\xA0", /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.verify_email.contact_us",
        defaultMessage: "or contact our support team"
      }), "\xA0"), /*#__PURE__*/_react.default.createElement("a", {
        className: "underline",
        target: "_blank",
        href: "https://support.peerspace.com/hc/".concat(zendeskLocale, "/requests/new")
      }, "here")));
    }
  }]);
  return VerifyEmail;
}(_react.default.Component);
module.exports = (0, _reactIntl.injectIntl)(VerifyEmail);